// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `::ng-deep app-forms {
   background-color: #f7f8f9;
}
/*::ng-deep header {*/
   /*background: transparent !important;*/
/*}*/
.header {
   background-color: #09338d;
   color: #fff;
   padding: 50px 20px 0;
   position: relative;
   text-align: center;
}
.background {
   background: url('http://netloid.com/wp-content/uploads/2014/05/netloid_why-you-should-consider-glusterfs-for-your-network-attached-storage-needs.jpg') center 25%;
   background-size: cover;
   opacity: .6;
   position: absolute;
   left: 0;
   top: 0;
   right: 0;
   bottom: 0;
}
.header h1 {
   font-size: 30px;
   position: relative;
}
.header::ng-deep .mat-select-value, .header::ng-deep .mat-select-arrow {
   color: #fff;
}
.header::ng-deep .mat-select-value-text {
   line-height: normal;
}
.header::ng-deep .mat-select-underline {
   background: none;
}
::ng-deep .mat-select-panel {
   margin-top: 40px;
}
.over-all {
   margin: auto;
   padding: 40px 1em 20px;
   position: relative;
}
.over-all>div {
   flex-grow: 1;
   flex-shrink: 1;
   font-size: 12px;
   position: relative;
   text-transform: uppercase;
}
.over-all .count {
   border-radius: 50%;
   font-size: 30px;
   font-weight: 300;
   line-height: 48px;
   width: 48px;
   height: 48px;
   margin: 0 auto 10px;
}
.over-all .c0 {
   background-color: #2ab4c0;
}
.over-all .c1 {
   background-color: #ba68c8;
}
.over-all .c2 {
   background-color: #ffa726;
}
.over-all .c3 {
   background-color: #ef5350;
}
.over-all .c4 {
   background-color: #8bc34a;
}
.over-all a {
   color: #fff;
   cursor: pointer;
   font-weight: bold;
}
.over-all i {
   display: inline-block;
   margin-right: 5px;
}
.over-all .selector {
   width: 0;
   height: 0;
   border: 12px solid transparent;
   border-top-width: 0;
   border-bottom-color: #f7f8f9;
   position: absolute;
   bottom: 0;
   left: 0;
}
.slide {
   transition: left 400ms ease-in-out 0ms;
}

.container {
   justify-content: center;
   padding: 10px;
}
.category {
   padding: 1em;
}
.category, .content {
   list-style: none;
   margin: 0;
   padding: 0;
}
.category, .over-all {
   min-width: 900px;
   width: 900px;
}
.category .fa-angle-down {
   cursor: pointer;
   margin-right: 5px;
   transition: transform .4s;
}
.collapse {
   transform: rotate(-90deg);
}
.category>li {
   overflow: hidden;
}
.category .section {
   padding: 10px 0;
}
.category .line {
   background-color: rgba(0,0,0,.1);
   height: 1px;
   margin-left: 10px;
}

.content {
   overflow: hidden;
   position: relative;
}
.content .gradient {
   background: linear-gradient(transparent 50%, #f7f8f9);
   position: absolute;
   bottom: 0;
   left: 0;
   right: 0;
   height: 120px;
}
.content li {
   background-color: #fff;
   border-radius: 2px;
   box-shadow: 0 1px 3px rgba(0,0,0,0.1);
   display: inline-block;
   margin: 10px 0 50px;
   padding: 20px 10px;
   width: 180px;
}
.content li + li {
   margin-left: 20px;
}
.category>li:last-child li {
   margin-bottom: 25px;
}
.content .title {
   font-weight: bold;
   text-align: center;
   overflow: hidden;
   white-space: nowrap;
   text-overflow: ellipsis;
}
.content .desc {
   font-size: 11px;
   opacity: .6;
   margin: 10px auto;
   text-align: center;
   overflow: hidden;
   white-space: nowrap;
   text-overflow: ellipsis;
}
.content img {
   display: block;
   margin: 10px auto;
   height: 80px;
   width: 80px;
   object-fit: contain;
}
.content button {
   background-color: #2ab4c0;
   color: #fff;
   cursor: pointer;
   border: none;
   border-radius: 2em;
   display: block;
   font-size: 12px;
   margin: auto;
   outline: none;
   padding: 4px;
   transition: background-color .2s;
   text-transform: uppercase;
   width: 100px;
}
.content button:active {
   background-color: #18929d;
}
.content .status {
   color: #2ab4c0;
   font-size: 12px;
   padding: 4px;
   text-align: center;
}
.content .status i {
   margin-right: .5em;
}
.controls {
   font-size: 12px;
   font-weight: bold;
   padding: 10px 0;
   text-align: right;
   text-transform: uppercase;
}
.controls span {
   cursor: pointer;
   display: inline-block;
}
.controls span:hover {
   color: #2ab4c0;
}
.controls span:not(:first-child) {
   margin-left: 1.5em;
}
.controls i {
   margin: 0 5px;
}
.options {
   background-color: rgba(0,0,0,.1);
   border-radius: 2em;
   margin-left: 10px;
   padding: 5px 20px;
   text-align: center;
}
.options i {
   cursor: pointer;
}
.options i + i {
   margin-left: 2em;
}
.options i:hover {
   color: #18929d;
}
`, "",{"version":3,"sources":["webpack://./src/app/e-form/form/form.component.css"],"names":[],"mappings":"AAAA;GACG,yBAAyB;AAC5B;AACA,qBAAqB;GAClB,sCAAsC;AACzC,IAAI;AACJ;GACG,yBAAyB;GACzB,WAAW;GACX,oBAAoB;GACpB,kBAAkB;GAClB,kBAAkB;AACrB;AACA;GACG,iKAAiK;GACjK,sBAAsB;GACtB,WAAW;GACX,kBAAkB;GAClB,OAAO;GACP,MAAM;GACN,QAAQ;GACR,SAAS;AACZ;AACA;GACG,eAAe;GACf,kBAAkB;AACrB;AACA;GACG,WAAW;AACd;AACA;GACG,mBAAmB;AACtB;AACA;GACG,gBAAgB;AACnB;AACA;GACG,gBAAgB;AACnB;AACA;GACG,YAAY;GACZ,sBAAsB;GACtB,kBAAkB;AACrB;AACA;GACG,YAAY;GACZ,cAAc;GACd,eAAe;GACf,kBAAkB;GAClB,yBAAyB;AAC5B;AACA;GACG,kBAAkB;GAClB,eAAe;GACf,gBAAgB;GAChB,iBAAiB;GACjB,WAAW;GACX,YAAY;GACZ,mBAAmB;AACtB;AACA;GACG,yBAAyB;AAC5B;AACA;GACG,yBAAyB;AAC5B;AACA;GACG,yBAAyB;AAC5B;AACA;GACG,yBAAyB;AAC5B;AACA;GACG,yBAAyB;AAC5B;AACA;GACG,WAAW;GACX,eAAe;GACf,iBAAiB;AACpB;AACA;GACG,qBAAqB;GACrB,iBAAiB;AACpB;AACA;GACG,QAAQ;GACR,SAAS;GACT,8BAA8B;GAC9B,mBAAmB;GACnB,4BAA4B;GAC5B,kBAAkB;GAClB,SAAS;GACT,OAAO;AACV;AACA;GACG,sCAAsC;AACzC;;AAEA;GACG,uBAAuB;GACvB,aAAa;AAChB;AACA;GACG,YAAY;AACf;AACA;GACG,gBAAgB;GAChB,SAAS;GACT,UAAU;AACb;AACA;GACG,gBAAgB;GAChB,YAAY;AACf;AACA;GACG,eAAe;GACf,iBAAiB;GACjB,yBAAyB;AAC5B;AACA;GACG,yBAAyB;AAC5B;AACA;GACG,gBAAgB;AACnB;AACA;GACG,eAAe;AAClB;AACA;GACG,gCAAgC;GAChC,WAAW;GACX,iBAAiB;AACpB;;AAEA;GACG,gBAAgB;GAChB,kBAAkB;AACrB;AACA;GACG,qDAAqD;GACrD,kBAAkB;GAClB,SAAS;GACT,OAAO;GACP,QAAQ;GACR,aAAa;AAChB;AACA;GACG,sBAAsB;GACtB,kBAAkB;GAClB,qCAAqC;GACrC,qBAAqB;GACrB,mBAAmB;GACnB,kBAAkB;GAClB,YAAY;AACf;AACA;GACG,iBAAiB;AACpB;AACA;GACG,mBAAmB;AACtB;AACA;GACG,iBAAiB;GACjB,kBAAkB;GAClB,gBAAgB;GAChB,mBAAmB;GACnB,uBAAuB;AAC1B;AACA;GACG,eAAe;GACf,WAAW;GACX,iBAAiB;GACjB,kBAAkB;GAClB,gBAAgB;GAChB,mBAAmB;GACnB,uBAAuB;AAC1B;AACA;GACG,cAAc;GACd,iBAAiB;GACjB,YAAY;GACZ,WAAW;GACX,mBAAmB;AACtB;AACA;GACG,yBAAyB;GACzB,WAAW;GACX,eAAe;GACf,YAAY;GACZ,kBAAkB;GAClB,cAAc;GACd,eAAe;GACf,YAAY;GACZ,aAAa;GACb,YAAY;GACZ,gCAAgC;GAChC,yBAAyB;GACzB,YAAY;AACf;AACA;GACG,yBAAyB;AAC5B;AACA;GACG,cAAc;GACd,eAAe;GACf,YAAY;GACZ,kBAAkB;AACrB;AACA;GACG,kBAAkB;AACrB;AACA;GACG,eAAe;GACf,iBAAiB;GACjB,eAAe;GACf,iBAAiB;GACjB,yBAAyB;AAC5B;AACA;GACG,eAAe;GACf,qBAAqB;AACxB;AACA;GACG,cAAc;AACjB;AACA;GACG,kBAAkB;AACrB;AACA;GACG,aAAa;AAChB;AACA;GACG,gCAAgC;GAChC,kBAAkB;GAClB,iBAAiB;GACjB,iBAAiB;GACjB,kBAAkB;AACrB;AACA;GACG,eAAe;AAClB;AACA;GACG,gBAAgB;AACnB;AACA;GACG,cAAc;AACjB","sourcesContent":["::ng-deep app-forms {\n   background-color: #f7f8f9;\n}\n/*::ng-deep header {*/\n   /*background: transparent !important;*/\n/*}*/\n.header {\n   background-color: #09338d;\n   color: #fff;\n   padding: 50px 20px 0;\n   position: relative;\n   text-align: center;\n}\n.background {\n   background: url('http://netloid.com/wp-content/uploads/2014/05/netloid_why-you-should-consider-glusterfs-for-your-network-attached-storage-needs.jpg') center 25%;\n   background-size: cover;\n   opacity: .6;\n   position: absolute;\n   left: 0;\n   top: 0;\n   right: 0;\n   bottom: 0;\n}\n.header h1 {\n   font-size: 30px;\n   position: relative;\n}\n.header::ng-deep .mat-select-value, .header::ng-deep .mat-select-arrow {\n   color: #fff;\n}\n.header::ng-deep .mat-select-value-text {\n   line-height: normal;\n}\n.header::ng-deep .mat-select-underline {\n   background: none;\n}\n::ng-deep .mat-select-panel {\n   margin-top: 40px;\n}\n.over-all {\n   margin: auto;\n   padding: 40px 1em 20px;\n   position: relative;\n}\n.over-all>div {\n   flex-grow: 1;\n   flex-shrink: 1;\n   font-size: 12px;\n   position: relative;\n   text-transform: uppercase;\n}\n.over-all .count {\n   border-radius: 50%;\n   font-size: 30px;\n   font-weight: 300;\n   line-height: 48px;\n   width: 48px;\n   height: 48px;\n   margin: 0 auto 10px;\n}\n.over-all .c0 {\n   background-color: #2ab4c0;\n}\n.over-all .c1 {\n   background-color: #ba68c8;\n}\n.over-all .c2 {\n   background-color: #ffa726;\n}\n.over-all .c3 {\n   background-color: #ef5350;\n}\n.over-all .c4 {\n   background-color: #8bc34a;\n}\n.over-all a {\n   color: #fff;\n   cursor: pointer;\n   font-weight: bold;\n}\n.over-all i {\n   display: inline-block;\n   margin-right: 5px;\n}\n.over-all .selector {\n   width: 0;\n   height: 0;\n   border: 12px solid transparent;\n   border-top-width: 0;\n   border-bottom-color: #f7f8f9;\n   position: absolute;\n   bottom: 0;\n   left: 0;\n}\n.slide {\n   transition: left 400ms ease-in-out 0ms;\n}\n\n.container {\n   justify-content: center;\n   padding: 10px;\n}\n.category {\n   padding: 1em;\n}\n.category, .content {\n   list-style: none;\n   margin: 0;\n   padding: 0;\n}\n.category, .over-all {\n   min-width: 900px;\n   width: 900px;\n}\n.category .fa-angle-down {\n   cursor: pointer;\n   margin-right: 5px;\n   transition: transform .4s;\n}\n.collapse {\n   transform: rotate(-90deg);\n}\n.category>li {\n   overflow: hidden;\n}\n.category .section {\n   padding: 10px 0;\n}\n.category .line {\n   background-color: rgba(0,0,0,.1);\n   height: 1px;\n   margin-left: 10px;\n}\n\n.content {\n   overflow: hidden;\n   position: relative;\n}\n.content .gradient {\n   background: linear-gradient(transparent 50%, #f7f8f9);\n   position: absolute;\n   bottom: 0;\n   left: 0;\n   right: 0;\n   height: 120px;\n}\n.content li {\n   background-color: #fff;\n   border-radius: 2px;\n   box-shadow: 0 1px 3px rgba(0,0,0,0.1);\n   display: inline-block;\n   margin: 10px 0 50px;\n   padding: 20px 10px;\n   width: 180px;\n}\n.content li + li {\n   margin-left: 20px;\n}\n.category>li:last-child li {\n   margin-bottom: 25px;\n}\n.content .title {\n   font-weight: bold;\n   text-align: center;\n   overflow: hidden;\n   white-space: nowrap;\n   text-overflow: ellipsis;\n}\n.content .desc {\n   font-size: 11px;\n   opacity: .6;\n   margin: 10px auto;\n   text-align: center;\n   overflow: hidden;\n   white-space: nowrap;\n   text-overflow: ellipsis;\n}\n.content img {\n   display: block;\n   margin: 10px auto;\n   height: 80px;\n   width: 80px;\n   object-fit: contain;\n}\n.content button {\n   background-color: #2ab4c0;\n   color: #fff;\n   cursor: pointer;\n   border: none;\n   border-radius: 2em;\n   display: block;\n   font-size: 12px;\n   margin: auto;\n   outline: none;\n   padding: 4px;\n   transition: background-color .2s;\n   text-transform: uppercase;\n   width: 100px;\n}\n.content button:active {\n   background-color: #18929d;\n}\n.content .status {\n   color: #2ab4c0;\n   font-size: 12px;\n   padding: 4px;\n   text-align: center;\n}\n.content .status i {\n   margin-right: .5em;\n}\n.controls {\n   font-size: 12px;\n   font-weight: bold;\n   padding: 10px 0;\n   text-align: right;\n   text-transform: uppercase;\n}\n.controls span {\n   cursor: pointer;\n   display: inline-block;\n}\n.controls span:hover {\n   color: #2ab4c0;\n}\n.controls span:not(:first-child) {\n   margin-left: 1.5em;\n}\n.controls i {\n   margin: 0 5px;\n}\n.options {\n   background-color: rgba(0,0,0,.1);\n   border-radius: 2em;\n   margin-left: 10px;\n   padding: 5px 20px;\n   text-align: center;\n}\n.options i {\n   cursor: pointer;\n}\n.options i + i {\n   margin-left: 2em;\n}\n.options i:hover {\n   color: #18929d;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
